import { Pipe, PipeTransform, inject } from '@angular/core';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import { DvSettingsMenuItem } from '@devinco/ui/legacy';
import { TranslateService } from '@ngx-translate/core';
import { VtSettingsMenuItem } from '@shared/interfaces/settings-menu-item';
import { Observable, map, take } from 'rxjs';

/** Hides settings menu items depending on permissions array values.
 * Translates menu item label.
 */
@Pipe({
  name: 'settingsMenuItemPerms',
})
export class SettingsMenuItemPermissionsPipe implements PipeTransform {
  private rolesAndPermissionsService = inject(UserRolesAndPermissionsService);
  private translate = inject(TranslateService);

  transform(data: VtSettingsMenuItem[]): Observable<DvSettingsMenuItem[]> {
    return this.rolesAndPermissionsService.getUserRolesAndPermissions().pipe(
      take(1),
      map(({ Permissions }) => {
        data.forEach(item => {
          item.label = this.translate.instant(item.label || '');
          if (item.permissions) {
            item.hide = !item.permissions.every(permission =>
              Permissions.includes(permission)
            );
          }
        });
        return data;
      })
    );
  }
}
